import { render, staticRenderFns } from "./payrollDashboard.vue?vue&type=template&id=16b6ea68&scoped=true"
import script from "./payrollDashboard.vue?vue&type=script&lang=js"
export * from "./payrollDashboard.vue?vue&type=script&lang=js"
import style0 from "./payrollDashboard.vue?vue&type=style&index=0&id=16b6ea68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b6ea68",
  null
  
)

export default component.exports